import React from "react";
import "../styles/ServerError.css";

const ServerFailureMatrix = () => {
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <div className="servermatrix-wrapper-v92">
      <div className="servermatrix-card-v92">

        <div className="servermatrix-errorcode-v92">
          500
        </div>

        <h1 className="servermatrix-title-v92">
          Internal Server Error
        </h1>

        <p className="servermatrix-text-v92">
          Something went wrong on our server.
          Please try again after some time.
        </p>

        <div className="servermatrix-btnbox-v92">

          <button
            className="servermatrix-retrybtn-v92"
            onClick={refreshPage}
          >
            Retry
          </button>

          <a
            href="/"
            className="servermatrix-homebtn-v92"
          >
            Go To Home
          </a>

        </div>

      </div>
    </div>
  );
};

export default ServerFailureMatrix;